import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';

import creedImage from '../../../../../assets/images/CreedSection.webp';
import SessionPill from '../../../../../components/SessionPill';
import { JourneyButton } from '../StorySection/styles';
import { CREED_CONTENT, CREED_BELIEFS } from './constants';
import {
  CreedSectionWrapper,
  CreedContainer,
  CreedLeftColumn,
  CreedImage,
  CreedRightColumn,
  SectionHeading,
  SectionSubtext,
  CreedPillsContainer,
  CreedButtonContainer,
} from './styles';

const CreedSection = () => {
  const navigate = useNavigate();

  const handleExploreServicesClick = () => {
    navigate('/services');
  };

  return (
    <CreedSectionWrapper>
      <CreedContainer>
        <CreedLeftColumn>
          <CreedImage alt="Nirva Creed" src={creedImage} />
        </CreedLeftColumn>
        <CreedRightColumn>
          <CreedPillsContainer>
            <Box>
              <SectionHeading>{CREED_CONTENT.title}</SectionHeading>
              <SectionSubtext>{CREED_CONTENT.subtitle}</SectionSubtext>
            </Box>
            {CREED_BELIEFS.map((belief, index) => (
              <SessionPill key={index}>{belief}</SessionPill>
            ))}
          </CreedPillsContainer>
          <CreedButtonContainer>
            <JourneyButton
              variant="contained"
              onClick={handleExploreServicesClick}
              text={CREED_CONTENT.buttonText}
            />
          </CreedButtonContainer>
        </CreedRightColumn>
      </CreedContainer>
    </CreedSectionWrapper>
  );
};

export default CreedSection;
